import { DEFAULT_WIDTH } from "plugins/PDFv2/PDFSnapshotContainer"
import { DEFAULT_HEIGHT } from "../PDFLegend"
import { LegendItemProps } from "./useLegendItems"

export const isLegendItemInPDFSnapshot = (
    x: number,
    y: number,
    legendProps: LegendItemProps,
    legendSize: number,
    legendPosition: string
) => {
    const { offsetX, offsetY, width, height } = legendProps
    if (legendPosition === "right") {
        const legendWidth = (legendSize * height) / DEFAULT_HEIGHT
        return (
            x > offsetX && x < offsetX + width - legendWidth && y > offsetY && y < offsetY + height
        )
    } else {
        const legendHeight = (legendSize * width) / DEFAULT_WIDTH
        return (
            x > offsetX && x < offsetX + width && y > offsetY && y < offsetY + height - legendHeight
        )
    }
}
